export default function AppleSignInButton({ disabled, label, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="flex w-full items-center justify-center gap-2 rounded-xl border border-black bg-black px-4 py-3 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50"
    >
      <svg
        className="h-5 w-5"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M17.05 12.54c-.03-3.18 2.6-4.73 2.72-4.8a5.84 5.84 0 0 0-4.61-2.5c-1.94-.2-3.82 1.16-4.8 1.16-1 0-2.5-1.14-4.13-1.1A6.1 6.1 0 0 0 1.1 8.43c-2.23 3.86-.57 9.54 1.57 12.66 1.07 1.53 2.31 3.23 3.94 3.17 1.59-.07 2.18-1.02 4.1-1.02 1.9 0 2.46 1.02 4.12.98 1.71-.03 2.79-1.53 3.82-3.08a12.65 12.65 0 0 0 1.75-3.57 5.51 5.51 0 0 1-3.35-5.03ZM13.89 3.18A5.57 5.57 0 0 0 15.16-.8a5.67 5.67 0 0 0-3.68 1.9 5.3 5.3 0 0 0-1.3 3.82 4.69 4.69 0 0 0 3.71-1.74Z" transform="translate(1.25 .75) scale(.9)" />
      </svg>
      <span>{label}</span>
    </button>
  );
}
